
import { useEffect } from "react";
import { StrategyPerformance } from "@/types/strategy-types";

type AdminDataLoaderProps = {
  userRole: string | null;
  providerId: string | null;
  loadUsers: () => Promise<void>;
  loadStrategies: () => Promise<void>;
  loadProviders: () => Promise<void>;
  loadLeadAccounts: () => Promise<void>;
  loadAccounts: () => Promise<void>;
  fetchAccountPerformances: () => Promise<StrategyPerformance[]>;
  fetchStripeSubscriptions: () => Promise<any>;
  setAccountPerformances: (performances: StrategyPerformance[]) => void;
  setStripeSubscriptions: (subscriptions: any) => void;
};

export const useAdminDataLoader = ({
  userRole,
  providerId,
  loadUsers,
  loadStrategies,
  loadProviders,
  loadLeadAccounts,
  loadAccounts,
  fetchAccountPerformances,
  fetchStripeSubscriptions,
  setAccountPerformances,
  setStripeSubscriptions
}: AdminDataLoaderProps) => {
  useEffect(() => {
    if (userRole) {
      const loadData = async () => {
        if (userRole === 'admin') {
          await Promise.all([
            loadUsers(), 
            loadStrategies(), 
            loadProviders(),
            loadLeadAccounts(),
            loadAccounts()
          ]);
          
          const performances = await fetchAccountPerformances();
          setAccountPerformances(performances);
          
          const subscriptionStats = await fetchStripeSubscriptions();
          setStripeSubscriptions(subscriptionStats);
        } else if (userRole === 'strategy_provider') {
          await Promise.all([
            loadStrategies(),
            loadProviders(), 
            loadLeadAccounts(),
            loadAccounts()
          ]);
          
          const performances = await fetchAccountPerformances();
          setAccountPerformances(performances);
        }
      };

      loadData();
    }
  }, [userRole, providerId]);
};
